// 9fbef606107a605d69c0edbcd8029e5d
import { PROMOTIONS_CONSTANT } from './Promotions.constants';

export const fetchAllPromotions = (payload) => {
  return {
    type: PROMOTIONS_CONSTANT.FETCH_ALL_PROMOTIONS,
    payload,
  };
};

export const fetchPromotionsDetails = (payload) => {
  return {
    type: PROMOTIONS_CONSTANT.FETCH_PROMOTION_DETAILS,
    payload,
  };
};

export const setAllPromotions = (payload) => {
  return {
    type: PROMOTIONS_CONSTANT.SET_ALL_PROMOTIONS,
    payload,
  };
};

export const setPromotionsDetails = (payload) => {
  return {
    type: PROMOTIONS_CONSTANT.SET_PROMOTIONS_DETAILS,
    payload,
  };
};

export const setAppliedPromotion = (payload) => ({
  type: PROMOTIONS_CONSTANT.SET_APPLIED_PROMOTION,
  payload,
});

export const removeAppliedPromotion = (payload) => ({
  type: PROMOTIONS_CONSTANT.REMOVE_APPLIED_PROMOTION,
  payload,
});

export const fetchAppliedPromotions = () => ({
  type: PROMOTIONS_CONSTANT.FETCH_APPLIED_PROMOTIONS,
});

export const setCachedPromotions = (payload) => ({
  type: PROMOTIONS_CONSTANT.SET_CACHED_PROMOTIONS,
  payload,
});

export const setUpdateCheckbox = (payload) => ({
  type: PROMOTIONS_CONSTANT.UPDATE_CHECKBOX,
  payload,
});

export const resetAppliedPromotions = (payload) => ({
  type: PROMOTIONS_CONSTANT.RESET_APPLIED_PROMOTIONS,
  payload,
});

export const resetRemovedPromotions = (payload) => ({
  type: PROMOTIONS_CONSTANT.RESET_REMOVED_PROMOTIONS,
  payload,
});

export const setAllOfferTypeBasedPromotionsData = (payload) => {
  return {
    type: PROMOTIONS_CONSTANT.SET_ALL_OFFER_TYPE_BASED_PROMOTIONS_DATA,
    payload,
  };
};
